import {
  formatDate,
  formatFullFormOfAddress,
  formatFullHouseNumber,
  getLandlineOrMobileNumber,
} from './formatter';
import useInitStore from '../store/init';
import useOrderStore from '../store/order';
import type { Address } from '../types/address';
import type { StepOrderRequestData, StepOrdererData } from '../types/step-data';

function buildCustomerFields(
  { contact, household, invoiceAddress }: StepOrdererData,
  connectionAddress: Address,
): Record<string, unknown> {
  const {
    companyName,
    customerId,
    dateOfBirth,
    isCompany,
  } = household;

  const address = invoiceAddress ?? connectionAddress;

  return {
    '1_Vor_Nachname_Firma': isCompany ? companyName : formatFullFormOfAddress(household),
    // This field contains an extra space in Osnatel documents
    // TODO: Tell the client to fix their documents
    '1_Vor_Nachname_ Firma': isCompany ? companyName : formatFullFormOfAddress(household),
    '1_E-Mail': contact.email,
    '1_Geburtsdatum': dateOfBirth ? formatDate(dateOfBirth) : '',
    '1_PLZ': address.zipCode,
    '1_Ort': address.city,
    '1_Telefon': getLandlineOrMobileNumber(contact),
    '1_Straße': address.street,
    '1_Hausnummer': formatFullHouseNumber(address),
    '1_Kunden_Vertragsnummer': customerId ?? '',
  };
}

function buildAddressFields(address: Address): Record<string, unknown> {
  return {
    '2_Ort': address.city,
    '2_PLZ': address.zipCode,
    '2_Straße': address.street,
    '2_Ortsteil': '',
    '2_Hausnummer': formatFullHouseNumber(address),
  };
}

function buildOrderRequestFields({ connectionPoint, price }: StepOrderRequestData)
: Record<string, unknown> {
  return {
    '5_Hausanschlusspreis': price,
    '5_Hausanschlussort': connectionPoint,
    '5_Wohnungsanzahl': '',
  };
}

export default function buildHouseConnectionOnlyFields(): Record<string, unknown> {
  const { paramsAddress } = useInitStore();
  const { ordererData, orderRequestData } = useOrderStore();

  return {
    ...buildCustomerFields(ordererData!, paramsAddress!),

    ...buildAddressFields(paramsAddress!),

    ...buildOrderRequestFields(orderRequestData!),
  };
}
